const BreakPoints = {
  XS : 480,
  S  : 640,
  M  : 768,
  L  : 960,
  XL : 1140,
};

export default BreakPoints;
